import { ReactElement, useMemo } from 'react'
import Markdown, { Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { createLruCache } from '../utils/createLruCache'

const MAX_CACHED_MESSAGES = 300
const REMARK_PLUGINS = [remarkGfm]

const trees = createLruCache<string, ReactElement>(MAX_CACHED_MESSAGES)

export const clearMarkdownCache = () => trees.clear()

const parseMarkdown = (content: string, components: Components) =>
  Markdown({ children: content, remarkPlugins: REMARK_PLUGINS, components })

// Keyed by text alone, so `components` must be a module-level constant that closes over nothing.
export const useCachedMarkdown = (content: string, components: Components, cacheable: boolean) =>
  useMemo(() => {
    if (!cacheable) return parseMarkdown(content, components)

    const cached = trees.get(content)
    if (cached) return cached

    const tree = parseMarkdown(content, components)
    trees.set(content, tree)
    return tree
  }, [content, components, cacheable])
